import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-radio-button-formly',
    templateUrl: './radio-button-formly.component.html',
    styleUrls: ['./radio-button-formly.component.scss'],
    imports: [MatRadioGroup, FormsModule, ReactiveFormsModule, MatRadioButton, AsyncPipe, TranslatePipe]
})
export class RadioButtonFormlyComponent extends FieldType<FieldTypeConfig> {

}
